<template>
	<v-container id="regular-tables-view" fluid tag="section">
		<material-card icon="mdi-format-list-numbered-rtl" icon-small title="گزارش تجمیعی وام های اسپانسری بر اساس تاریخ" color="accent" :loading="loading">
			<v-row>
				<v-col cols="12" style="padding:0 40px 40px">
					<v-row>
						<v-col cols="12" md="3">
						</v-col>
						<v-col cols="12" md="6">
							<date-navigator v-model="dateRange" :options="{ rangeMode: true, defaultEmpty: true }">
								<div class="text-center">
									<v-btn color="primary" dark class="mx-1" @click="loadData">
										دریافت اطلاعات
									</v-btn>
								</div>
							</date-navigator>
						</v-col>
						<v-col cols="12" md="3" class="d-flex align-center justify-end">
							<export-excel :items="items" :headers="headers" :fileName="excelFileName">
							</export-excel>
						</v-col>
					</v-row>
					<v-row>
						<v-col cols="12" md="12">
							<v-text-field v-model="search" append-icon="mdi-magnify" label="اطلاعات مورد نظر خود جهت جستجو وارد کنید" single-line hide-details class="mb-5" />
						</v-col>
						<v-col cols="12">
							<v-data-table :headers="headers" :items="items" :items-per-page="500" :search="search" class="elevation-1">
								<template v-slot:item="row">
									<tr>
										<td>
											<div @click="loans(row.item)" style="cursor:pointer">
												<div>{{ row.item.title }}</div>
												<div class="blue--text">مشاهده جزئیات</div>
											</div>
										</td>
										<td class="text-center">
											{{ row.item.count }}
										</td>
										<td class="text-center">
											{{ row.item.sum.toString().toPriceFormat() }}
										</td>
										<td class="text-center">
											{{ row.item.paid.toString().toPriceFormat() }}
										</td>
										<td class="text-center">
											<div @click="sponsorePaids(row.item)" style="cursor:pointer">
												<div>{{ row.item.sponsorePaid.toString().toPriceFormat() }}</div>
												<div class="blue--text">مشاهده جزئیات</div>
											</div>
										</td>
										<td class="text-center">
											{{ row.item.remain.toString().toPriceFormat() }}
										</td>
									</tr>
								</template>
							</v-data-table>
						</v-col>
					</v-row>
				</v-col>
			</v-row>
		</material-card>
		<confirm-dlg ref="confirm" />
		<div class="py-3" />
		<v-dialog v-model="dialogLoans" scrollable max-width="1200px">
			<v-card>
				<v-card-title>
					<div><span class="headline">لیست وام های {{ selectedItem.title }}</span></div>
					<v-spacer />
					<v-btn @click="dialogLoans = false" icon>
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text>
					<loans ref="loans" :data="selectedItem" />
				</v-card-text>
			</v-card>
		</v-dialog>
		<v-dialog v-model="dialogSponsoredPaids" scrollable max-width="1200px">
			<v-card>
				<v-card-title>
					<div><span class="headline">لیست پرداختی های اسپانسری {{ selectedItem2.title }}</span></div>
					<v-spacer />
					<v-btn @click="dialogSponsoredPaids = false" icon>
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text>
					<sponsored-paids ref="sponsoredPaids" :data="selectedItem2" />
				</v-card-text>
			</v-card>
		</v-dialog>
	</v-container>
</template>

<script>
	import api from '@/util/app-api'
	import toast from '@/util/toast'
	import VuePersianDatetimePicker from 'vue-persian-datetime-picker'

	export default {
		name: 'SponsoredLoans',
		components: {
			ConfirmDlg: () => import('@/components/Confirm'),
			'date-navigator': () => import('@/components/DateNavigator'),
			'loans': () => import('./SponsoredUserLoans'),
			'sponsored-paids': () => import('./SponsoredPaids'),
			'date-picker': VuePersianDatetimePicker,
		},
		data() {
			return {
				dialogLoans: false,
				dialogSponsoredPaids: false,
				selectedItem: {},
				selectedItem2: {},
				errorMessages: '',
				startDate: '',
				startDateValidatioin: '',
				endDateValidatioin: '',
				endDate: '',
				loadedReport_startDate: '',
				loadedReport_endDate: '',
				search: '',
				loading: false,
				headers: [
					{
						text: 'عنوان',
						align: 'start',
						sortable: true,
						value: 'title',
						width: '150'
					}, {
						text: 'تعداد',
						align: 'center',
						sortable: true,
						value: 'count',
						width: '100'
					}, {
						text: 'مجموع',
						align: 'center',
						sortable: true,
						value: 'sum',
					}, {
						text: 'اقساط پرداخت شده',
						align: 'center',
						sortable: true,
						value: 'paid',
					}, {
						text: 'پرداخت شده توسط اسپانسر',
						align: 'center',
						sortable: true,
						value: 'sponsorePaid',
					}, {
						text: 'مانده',
						align: 'center',
						sortable: true,
						value: 'remain',
					},
				],
				items: [],
				dateRange: { start: '', end: '' }
			}
		},
		computed: {
			excelFileName() {
				let name = 'گزارش تجمیعی وام های اسپانسری'
				if (this.startDate)
					name += ' از ' + this.startDate.toString().split('T')[0]
				if (this.endDate)
					name += ' تا ' + this.endDate.toString().split('T')[0]
				name += '.xls'
				return name
			}
		},
		mounted() {
		},
		methods: {
			loans(item) {
				this.selectedItem = { id: item.id, title: item.title, startDate: this.loadedReport_startDate, endDate: this.loadedReport_endDate }
				this.dialogLoans = true
				this.$nextTick(() => {
					this.$refs.loans.loadData()
				})
			},
			sponsorePaids(item) {
				this.selectedItem2 = { id: item.id, title: item.title, startDate: '', endDate: '' }
				this.dialogSponsoredPaids = true
				this.$nextTick(() => {
					this.$refs.sponsoredPaids.loadData()
				})
			},
			loadData() {
				this.loading = true
				api.get('admin/report/SponsoredLoans/?start=' + this.dateRange.start + '&end=' + this.dateRange.end, {})
					.then(
						response => {
							this.items = response
							this.loadedReport_startDate = this.dateRange.start
							this.loadedReport_endDate = this.dateRange.end
						})
					.catch(err => {
						toast.error(err.message)
					})
					.finally(x => { this.loading = false })
			},
		},
	}
</script>
<style></style>
